import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRPartners = createSelector([selectQbrState], (state) => state.documentPartners)
